import React from 'react';
import { useAbility } from '@casl/react';
import Icon from '../Icons';
import { AbilityContext } from '../../config/abilityContext';
import BasicDropdown from '../Utils/Dropdown/BasicDropdown';

const ApProcessIndexMassiveActions = ({ handleClick, model, disabledAction }) => {
  const ability = useAbility(AbilityContext);
  const actions = () => {
    const authorizedActions = [];
    if (ability.can('update', model)) {
      authorizedActions.push({
        icon: <Icon icon="close-circle-outline" height="16px" width="16px" style={{ marginRight: 5 }} />,
        key: 'close_month',
        props: {
          onClick: () => handleClick('close_month'),
          disabled: !disabledAction
        },
        title: 'Cerrar Anticipos'
      });
    }
    if (ability.can('index', model)) {
      authorizedActions.push({
        icon: <Icon icon="download-2" height="16px" width="16px" style={{ marginRight: 5 }} />,
        key: 'export',
        props: {
          onClick: () => handleClick('export'),
          disabled: !disabledAction
        },
        title: 'Descargar'
      });
    }
    if (ability.can('destroy', model)) {
      authorizedActions.push({
        icon: <Icon icon="trash" height="16px" width="16px" style={{ marginRight: 5 }} />,
        key: 'destroy',
        props: {
          onClick: () => handleClick('destroy'),
          disabled: !disabledAction
        },
        title: 'Eliminar'
      });
    }
    return authorizedActions;
  };

  return (
    <div className="mb-4">
      <BasicDropdown
        block
        items={actions()}
        noArrow
        right
        disabled={disabledAction}
        titleDrop={
          <span className="align-middle">
            Acciones Masivas <Icon icon="ellipsis-vertical" height="20px" width="20px" />
          </span>
        }
        variant="outline-primary"
      />
    </div>
  );
};

export default ApProcessIndexMassiveActions;
